module.exports = __webpack_public_path__ + "static/media/success.0a9ee243.png";